(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/host-channel.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/host-channel.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const _ref = svs.ticketUtility && svs.ticketUtility.data.gameloaderHelperConfig || {},
  lotteryCode = _ref.lotteryCode;
const log = new svs.core.log.Logger('tur:host-channel');
const getAccessCode = async state => {
  try {
    const domain = window.location.origin;
    const path = "".concat(svs.core.urlMapping.get('ticketsApi'), "/accesscode?state=").concat(state);
    const response = await fetch("".concat(domain).concat(path));
    if (!response.ok) {
      throw new Error('Failed to fetch access code');
    }
    const data = await response.json();
    return {
      gender: 'M',
      firstName: '',
      lastName: '',
      sessionToken: {
        value: data.accessCode,
        state,
        provider: lotteryCode
      }
    };
  } catch (e) {
    log.warn('Error fetching access code', e);
    svs.tur.apierrors.showErrorMessage({
      response: 0,
      onConfirm: () => svs.utils.url.navigate(svs.core.data.baseUrl)
    });
    throw new Error('Failed to fetch access code');
  }
};
class HostChannel {
  constructor(options) {
    _defineProperty(this, "type", '');
    _defineProperty(this, "name", '');
    _defineProperty(this, "demo", '');
    const type = options.type,
      name = options.name,
      listener = options.listener;
    this.options = options;
    this.type = type;
    this.name = name;
    this.gameMode = undefined;
    this.listener = listener;
    this.startTime = performance.now();
  }
  emitEvent(eventType, eventData) {
    this.listener(eventType, eventData);
    switch (eventType) {
      case 'TAG':
        break;
      case 'HAS_BET':
      case 'HAS_CLAIMED':
        log.info("EventType: ".concat(eventType, ", GameCode: ").concat(this.name, ", Mode: ").concat(this.gameMode));
        break;
      case 'PREBET':
        log.info("Time taken to prebet (MS): ".concat(Math.round(performance.now() - this.startTime)));
        return new Promise((resolve, reject) => {
          this.listener('HANDLE_PREBET', _objectSpread(_objectSpread({}, eventData), {}, {
            resolve,
            reject
          }));
        });
      default:
        break;
    }
  }

  updateGameMode(gameMode) {
    this.gameMode = gameMode;
    return new Promise(resolve => {
      resolve(gameMode);
    });
  }
  getGameMode() {
    return new Promise(resolve => {
      resolve(this.gameMode);
    });
  }

  getGameInformation() {
    const type = this.type,
      name = this.name;
    return new Promise(resolve => {
      resolve({
        type,
        name,
        label: ''
      });
    });
  }

  getGameConfiguration() {
    return new Promise(resolve => {
      resolve({
        theme: {
          id: 'default'
        },
        visualIdentity: {
          id: 'default',
          url: ''
        },
        logo: {
          url: ''
        },
        parameters: {}
      });
    });
  }
  getLocaleInformation() {
    return new Promise(resolve => {
      resolve({
        availableLanguages: ['en-US', 'da-DK'],
        activeLanguage: 'en-US',
        activeCurrency: 'DKK'
      });
    });
  }

  getUserInformation(forceAuthenticated, sessionTokenType, options) {
    return new Promise((resolve, reject) => {
      if (forceAuthenticated) {
        getAccessCode(options.state).then(resolve).catch(reject);
      } else {
        resolve({});
      }
    });
  }
  getPurseInformation() {
    return new Promise((resolve, reject) => {
      reject({});
    });
  }

  getHostInformation() {
    return new Promise(resolve => {
      resolve({});
    });
  }

  executeAction(actionId, parameters) {
    var _parameters$popup;
    this.listener(actionId, parameters);
    switch (actionId) {
      case 'CLOSE_GAME':
        break;
      case 'GAME_RULES':
        break;
      case 'GLOBAL_RULES':
        break;
      case 'OPEN_GAME':
        break;
      case 'OPEN_POPUP':
        if ((parameters === null || parameters === void 0 || (_parameters$popup = parameters.popup) === null || _parameters$popup === void 0 ? void 0 : _parameters$popup.level) === 'error') {
          svs.ticketgames.ticketUtility.utils.handleOpenPopError(parameters, () => {
            this.listener('CLOSE_GAME', {});
          });
        }
        break;
      default:
        break;
    }
    return new Promise(resolve => {
      resolve({});
    });
  }
}
setGlobal('svs.ticketgames.ticketUtility.utils.HostChannel', HostChannel);

 })(window);